import { render } from "./SendMail.vue?vue&type=template&id=3d271d1c&scoped=true"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "./SendMail.vue?vue&type=style&index=0&id=3d271d1c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d271d1c"]])

export default __exports__